const doc = [({"da":({"js":({"admin":({"photo_types":({"create_card":({"create_photo_type":"Opret fototype"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;